import FloatLabelInput from './container/index';

export default FloatLabelInput;



// WEBPACK FOOTER //
// ./src/components/page/FloatLabelInput/index.js